/*
 * This constant is imported into Cypress tests to allow the test wait for
 * the default delay between button click and navigation in the SingleSelectScreen
 *
 * This export does not seem to justify it's own file when it could be defined in SingleSelectScreen.tsx.
 * However, if this export is in a .tsx file, Cypress thrown an
 * 'An uncaught error was detected outside of a test' error when we import it in the Cypress test.
 * Hence it is in it's own .ts file.
 *
 * In November 2024, a trial of setting this to 0 in an attempt to reduce the run time of the Cypress autopilot tests
 * found very little reduction in run time. With 300ms, a the Nerva autopilot test on all variants took 21m52s.
 * When reduced to 0ms, the run time was 22m53s. When set to 3ms, execution time as 19m53s, so it appears this value
 * is not a significant factor in the run time of the autopilot tests.
 *
 * The SingleSelectScreen unit tests include a check that the delay between click and navigate is honoured,
 * so when the delay is set to 0ms, that unit test fails.
 */
export const SELECT_DELAY_DEFAULT_MS = 300;
